import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6746f22b099e/components/forms/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/app/[locale]/contact/contact.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleMapLazy"] */ "/tmp/8de6746f22b099e/components/ui/GoogleMapLazy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Section.module.css");
